<template>
  <div class="step3">
    <i class="iconfont icon-wancheng"></i>
    <span>完成，请用新手机号登录系统</span>
    <a
      href="javascript:;"
      @click="logout">{{ countdown }}秒后自动跳转</a>
  </div>
</template>

<script>
import {logout} from '@/util';
export default {
  data() {
    return {
      countdown: 5,
    };
  },
  methods: {
    startCountdown() {
      const time = setInterval(() => {
        if (this.countdown < 1) {
          clearInterval(time);
          logout();
        } else {
          this.countdown--;
        }
      }, 1000);
    },
    logout() {
      logout();
    },
  },
  mounted() {
    this.startCountdown();
  },
};
</script>
